module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "sp",
    attrs: {
      "id": "ch6"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "CT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/contents#c_ch6",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ePub-B"
  }, [_vm._v("It’s Easy to Trace the Tracks of My Tears")])])]), _vm._v(" "), _c('p', {
    staticClass: "DLF"
  }, [_c('span', {
    staticClass: "ePub-B"
  }, [_vm._v("10:02 a.m.")])]), _vm._v(" "), _c('p', {
    staticClass: "CO"
  }, [_vm._v("The bird is dead. And now I’m a blubbery mess. Which, when you think about it, doesn’t make a whole lot of sense. I didn’t even "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("know")]), _vm._v(" the bird. He could have been a total douche bag. He could have been the kind of bird that steals hot dogs right off your plate. Or poops on people’s windshields and doesn’t leave a note.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("But it’s not every day you see something die right in front of you. And at the hands of a dirty classroom window. Really, the crow should have known better. There’s no way the windows of this prison are clean enough for a bird to mistake them for air.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("So, in other words, the bird was a moron.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("At least I don’t have to worry about the tears smearing my eye makeup. That ship has long since sailed.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("The good news is, Tristan seems really concerned about me. He wraps his arms tightly around my back and lets me cry into his chest. He doesn’t even seem to mind that I’m totally smudging up his white T-shirt.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Shhh,” he coos, in that sultry soft voice he usually reserves for the stage. “It’s okay. He didn’t feel anything. He died instantly.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("He squeezes me closer and I can smell the piney scent of his aftershave. I can feel the contours of his chest muscles through his shirt. Tristan has what I like to call a sucker punch body. It’s the ultimate proof that looks can be deceiving. From the outside, he seems slightly on the scrawny side. His jeans and shirts always fit a little loose. His Adam’s apple protrudes from his neck and does this cute contraction when he swallows. But then he takes off his shirt and it’s like, "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("BAM!")]), _vm._v(" Sucker punch! Right to the gut. His muscles aren’t huge but they’re defined. Like wowza defined. And his chest is completely smooth.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Viking DNA,” he likes to joke. “We Scandinavians are freakishly hairless.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("At first it feels nice to be comforted by Tristan. I’m reminded of why I love him so much. He has such a gentle soul. A poet’s soul. And I’m certainly not gonna complain about being pressed up against his chest muscles. But then the sound of my own sniffling starts to echo in my ears and I’m reminded of our fight last night. And how I basically went from normal chill girlfriend to strung-out monster in thirty seconds flat.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Tristan hates drama. This has never been a secret. He told me as much the day we met. It was actually one of the first conversations we had. We were at a party at Daphne Gray’s house. Tristan had just broken up with Colby, his girlfriend for all of six weeks, and everyone knew about it. Tristan had a long history of short relationships. Maybe that’s because he always dated the same type of girl over and over and then broke up with them for the same exact reason. It’s like someone who complains about never losing weight but eats an entire box of Oreos every night.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("I push away from Tristan’s warm, inviting chest and wipe away my tears. “I’m okay,” I say. “Thanks.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("I have to remedy this. I can’t allow myself to become another melodramatic ex-girlfriend in Tristan’s life. Five months we’ve been dating. Five whole months. That’s longer than any of his past relationships. We even lasted through the summer, which, let’s face it, is like the kiss of death for high school romances. I have to prove once and for all that I’m still the same girl he fell in love with.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Señora Mendoza. Can I use the pass?”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("“En español,”")]), _vm._v(" she reminds me.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("“¿Puedo usar el pase?”")])]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("She smiles. "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("“Sí.”")])]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("I grab the straw sombrero from the hook on the wall and bolt out the door. It’s time to clean up this mess. Starting with my face.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1ed362e8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/chapter6.vue
// module id = 90
// module chunks = 0